import React, { useState } from 'react'
import { Text, NumberInput } from '.'

const PageSelector = ({ select, cancel, numPages, pageLimit, ...props }) => {
  const [err, setErr] = useState('')
  const [range, setRange] = useState([1, 1])

  const checkInput = () => {
    let err = ''
    const r = range[0] <= range[1] ? range : [range[1], range[0]]
    if (r[0] > 0 && !(r[1] > 0)) return select([r[0], r[0]])
    else if (!(r[0] > 0)) err = 'Please only input positive integers.'
    else if (Math.max(r[0], r[1]) > numPages)
      err = `The document only has ${numPages} pages.`
    else if (r[1] - r[0] > pageLimit - 1)
      err = `Up to ${pageLimit} pages can be imported at a time.`
    else return select(r)
    setErr(err)
  }

  const setRangeAt = (v, i) => {
    if (!(parseInt(v) > 0)) return
    let r = [...range]
    r[i] = Math.min(Math.max(1, parseInt(v)), numPages)
    let absRange = Math.abs(r[i] - r[1 - i]) + 1
    r[1 - i] =
      absRange <= pageLimit
        ? r[1 - i]
        : r[i] < r[1 - i]
        ? Math.min(r[i] + pageLimit - 1, numPages)
        : Math.max(r[i] - pageLimit + 1, 1)
    setRange(r)
  }

  return (
    <div
      className={`ui gp-PageSelector ${props.className}`}
      style={props.style}
    >
      <Text>
        Please select the page range you want to import (max {pageLimit} pages
        at a time):
      </Text>
      <div className='gp-PageSelector-inputs'>
        <NumberInput
          className='rounded'
          value={range[0]}
          dark
          increase={() => setRangeAt(range[0] + 1, 0)}
          decrease={() => setRangeAt(range[0] - 1, 0)}
          events={{ onChange: (v) => setRangeAt(v, 0) }}
        />
        <div className='divider'></div>
        <NumberInput
          className='rounded'
          value={range[1]}
          dark
          increase={() => setRangeAt(range[1] + 1, 1)}
          decrease={() => setRangeAt(range[1] - 1, 1)}
          events={{ onChange: (v) => setRangeAt(v, 1) }}
        />
      </div>
      {!!err.length && <Text>{err}</Text>}
      <div className='gp-PageSelector-actions'>
        <button onClick={checkInput} className='yes'>
          Confirm Selection
        </button>
        <button onClick={cancel} className='no'>
          Cancel
        </button>
      </div>
    </div>
  )
}

PageSelector.defaultProps = {
  className: '',
  style: {},
  pageLimit: 3
}

export default PageSelector
